// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:not([disabled])[readonly] {
  background-color: white;
}

.fa-calendar-times {
  color: #1D95D2;
}`, "",{"version":3,"sources":["webpack://./src/gamma/form/formquestion/bootstrap/date/date-input/date-input.component.scss"],"names":[],"mappings":"AACA;EACI,uBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ","sourcesContent":["\ninput:not([disabled])[readonly] {\n    background-color: white;\n}\n\n.fa-calendar-times {\n    color: #1D95D2;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
